<template>
  <div id="data-list-list-view" class="data-list-container">
    <EmptyList
      imgFileName="any.png"
      title="Нет чаевых"
      v-if="isFirstLoading && hasNoTips"
    />

    <section v-else>
      <div class="mb-5">
        <span class="amount">
          Всего чаевых
          <span class="amount--price">
            {{ totalAmountRubles }}&thinsp;₽
          </span>
        </span>
      </div>
      <vs-table
        ref="table"
        no-data-text="Нет чаевых"
        :max-items="itemsPerPage"
        search
        :data="payments"
        @search="handleSearch"
        @sort="handleSort"
        :sst="false"
        :pagination="payments.length > itemsPerPage"
      >
        <div
          slot="header"
          class="flex flex-wrap items-center flex-grow justify-between"
        >
          <div class="flex flex-wrap items-center">
            <datepicker
              class="mr-10 mt-2"
              :language="ru"
              clear-button
              placeholder="С"
              v-model="date_from"
              @input="handleDateFilter"
              :format="customFormatter"
            />
            <datepicker
              class="mr-10 mt-2"
              clear-button
              :language="ru"
              clearable
              placeholder="По"
              v-model="date_to"
              :format="customFormatter"
              @input="handleDateFilter"
            />
          </div>
        </div>
        <template slot="thead">
          <vs-th sort-key="amount_of_payment_to_employee_rubles">Сумма</vs-th>
          <vs-th sort-key="created">Дата</vs-th>
          <vs-th sort-key="state">Статус</vs-th>
          <vs-th>ID транзакции</vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ tr.amount_of_payment_to_employee_rubles }}&thinsp;₽
              </vs-td>
              <vs-td>
                <time>{{ tr.created }}</time>
              </vs-td>
              <vs-td>
                <vs-chip
                  :color="getOrderStatusColor(tr.state)"
                  class="product-order-status"
                  >{{ tr.status }}</vs-chip
                >
              </vs-td>
              <vs-td>
                {{ tr.order_id }}
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <!-- <vs-pagination
        :total="totalPages"
        v-model="page"
        @change="handleChangePage"
      ></vs-pagination> -->
    </section>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import debounce from 'lodash/debounce.js'
import { mapGetters } from 'vuex'
import CompanyService from '@/common/company.service'
import { ru } from 'vuejs-datepicker/src/locale'
// import AddNewDataSidebar from '../AddNewDataSidebar.vue'
export default {
  components: {
    Datepicker
  },
  data() {
    return {
      ru: ru,
      payments: [],
      payments_order: {},
      totalAmountRubles: 0,
      // successAmountRubles: 0,
      date_from: null,
      date_to: null,
      itemsPerPage: 25,
      totalPages: 1,
      page: 1,
      searchQuery: '',
      orderingQuery: '',
      isFirstLoading: true
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    hasNoTips() {
      return this.payments.length === 0
    }
  },
  filters: {
    tax_charge: function(value) {
      if (!value) return ''
      value = parseInt(value)
      value = value - 0.1 * value
      return value
    }
  },
  methods: {
    handleSearch: debounce(function(searching) {
      // this.searchQuery = searching
      // this.page = 1
      // this.isFirstLoading = false
      // this.getTranscations()
    }, 300),
    // handleChangePage(page) {
    //   this.page = page
    //   this.isFirstLoading = false
    //   this.getTranscations()
    // },
    handleSort(key, active) {
      // this.orderingQuery = active ? `-${key}` : `${key}`
      // this.isFirstLoading = false
      // this.getTranscations()
    },
    handleDateFilter() {
      this.isFirstLoading = false
      this.getTranscations()
    },
    getOrderStatusColor(status) {
      if (status === 'CR') return 'warning'
      if (status === 'SC') return 'success'
      if (status === 'FL') return 'danger'
      return 'primary'
    },
    customFormatter(date) {
      return new Intl.DateTimeFormat().format(new Date(date))
    },
    getTranscations() {
      this.$vs.loading()
      const payload = {
        employee: this.$route.params.employeeID ? this.$route.params.employeeID : this.currentUser.id
        // search: this.searchQuery,
        // ordering: this.orderingQuery,
        // page: this.page
      }
      if (this.date_from) {
        payload.created__gte = this.customFormatter(this.date_from)
      }
      if (this.date_to) {
        payload.created__lte = this.customFormatter(this.date_to)
      }
      CompanyService.getTranscations(payload).then(response => {
        this.payments = response.data.results
        this.totalAmountRubles = response.data.total_amount_rubles
          ? response.data.total_amount_rubles
          : '0'
        // this.successAmountRubles = response.data.success_amount_rubles
        //   ? response.data.success_amount_rubles
        //   : '0'
        // this.totalPages = Math.ceil(this.payments.length / this.itemsPerPage)
        this.$vs.loading.close()
      })
    }
  },
  created() {
    this.getTranscations()
  },
  mounted() {
  }
}
</script>
